import * as XLSX from 'xlsx';

export default function exportFlowDataToExcel(
    flowData: {
        early: [{
            date: {seconds: number},
            cumTasks: number
            }],
        late: [{
            date: {seconds: number},
            cumTasks: number
            }],
        expected: [{
            date: {seconds: number},
            cumTasks: number
            }]
        },
    projectName: string
) {
    const workbook = XLSX.utils.book_new();

    // set up the column headers
    const headers = [
        "date",
        "early",
        "late",
        "optimal"
    ];

    const dataMap = new Map();

    flowData.early.forEach((item: any) => {
        const dateKey = new Date(item.date.seconds * 1000).toLocaleDateString();
        if (!dataMap.has(dateKey)) {
            dataMap.set(dateKey, { early: item.cumTasks, late: null, optimal: null });
        } else {
            dataMap.get(dateKey).early = item.cumTasks;
        }
    });

    flowData.late.forEach((item: any) => {
        const dateKey = new Date(item.date.seconds * 1000).toLocaleDateString();
        if (!dataMap.has(dateKey)) {
            dataMap.set(dateKey, { early: null, late: item.cumTasks, optimal: null });
        } else {
            dataMap.get(dateKey).late = item.cumTasks;
        }
    });

    flowData.expected.forEach((item: any) => {
        const dateKey = new Date(item.date.seconds * 1000).toLocaleDateString();
        if (!dataMap.has(dateKey)) {
            dataMap.set(dateKey, { early: null, late: null, optimal: item.cumTasks });
        } else {
            dataMap.get(dateKey).optimal = item.cumTasks;
        }
    });

    // Map sprint data to worksheet format
    const worksheetData = [
        headers,
        ...flowData.early.map(item => [
            new Date(item.date.seconds * 1000).toLocaleDateString(),
            dataMap.get(new Date(item.date.seconds * 1000).toLocaleDateString()).early,
            dataMap.get(new Date(item.date.seconds * 1000).toLocaleDateString()).late,
            dataMap.get(new Date(item.date.seconds * 1000).toLocaleDateString()).optimal
        ])
    ];

    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Flow Data');

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, `${projectName}_Flow_Data_${new Date().getTime() / 1000}.xlsx`);
}